<template>
    <div class="language-picker"
         @click="toggle()"
         v-click-outside="close"
    >
        <img
            width="24"
            height="16"
            :src="'/assets/img/frontend-v3/flags/' + currentValue + '.svg'"
            :alt="currentValue"
            @keydown.enter="toggle()"
            tabindex="0"
            ref="currentFlag"
        >
        <div class="lp-list" :class="{ opened }">
            <img v-for="option in getOptions()"
                 width="24"
                 height="16"
                 @click.prevent="pick(option, false)"
                 :src="'/assets/img/frontend-v3/flags/' + option.value + '.svg'"
                 :alt="option.value"
                 tabindex="0"
                 @keydown.enter="pick(option, true)"
                 ref="option"
            >
        </div>
    </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
    name: "LanguagePicker",

    props: ['options', 'value'],

    data() {
        return {
            currentValue: this.value,
            opened: false,
        }
    },

    created() {

    },

    mounted() {

        // Listen to filter updates
        this.Bus.on('filter-url-changed', url => {

            setTimeout(() => {

                let urlski = window.location.href;

                // Update each option's url to the new filter value.
                this.options.forEach((item) => {
                    item.url = urlski + '?redirect-lang=' + item.value;
                });
            }, 1200);

        })
    },

    methods: {
        /**
         * Returns the set of options, sorted in such a way that the current value is at the top.
         */
        getOptions() {
            return this.options
                .map(item => ({
                    value: item.value || item,
                    url: item.url || null
                }))
                .sort(a =>
                    a.value === this.currentValue
                        ? -1
                        : 1
                );
        },

        /**
         * Toggles the list open or closed.
         */
        toggle() {
            this.opened = !this.opened;

            if (this.opened) {
                if (document.activeElement === this.$refs.currentFlag) {
                    this.$refs.option[0].focus();
                }
            }
        },

        /**
         * Forces the list to close.
         */
        close() {
            if (this.opened) {
                this.toggle();
            }
        },

        /**
         * Picks an option
         * @param {Object} option
         * @param {boolean} [toggle]
         */
        pick(option, toggle) {
            if (toggle) {
                this.toggle();
            }

            if (option.value === this.currentValue) {
                return;
            }

            this.currentValue = option.value;

            if (option.url) {
                window.location.href = option.url;
            } else {
                const params = new URLSearchParams(window.location.search);
                params.set('lang', option.value);
                window.location.search = params.toString();
            }
        }
    }
})
</script>

<style scoped>

</style>
